<template>
<div>
  <div style="height: 40px;margin: 10px 40px" v-if="tabs.length > 0">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
    <div class="add-open-btn" v-if="indexActive === 16 || indexActive === 17" @click="addOpen()">
      <strong>+</strong>
    </div>
  </div>
  <!--  16、330亲情号  -->
  <div v-if="indexActive === 16">
    <div class="content-info">
      <el-table v-if="indexActive === 16" ref="phoneTable" :data="phoneFamilyList" border style="width: 100%;" highlight-current-row size="mini">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="135" align="center"></el-table-column>
        <el-table-column prop="phone" label="电话" min-width="135" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="130">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editPhoneFamily(scope.row, scope.$index)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delPhoneFamily(scope.row, scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <!--  17、330白名单  -->
  <div v-if="indexActive === 17">
    <div class="content-info">
      <el-table v-if="indexActive === 17" ref="phoneTable" :data="phoneWhiteList" border style="width: 100%;" highlight-current-row size="mini">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="phone" label="电话" min-width="135" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="130">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editPhoneWhite(scope.row, scope.$index)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delPhoneWhite(scope.row, scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <!--  18、330闹钟  -->
  <div v-if="indexActive === 18">
    <div class="content-info">
      <el-table v-if="indexActive === 18" ref="phoneTable" :data="alarmClockList" border style="width: 100%;" highlight-current-row size="mini">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="time" label="提醒时间" min-width="100" align="center"></el-table-column>
        <el-table-column align="center" label="闹钟类型" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 0" style="color: #0bb20c">闹钟生效</span>
            <span v-if="scope.row.type === 1" style="color: #d96666">闹钟失效</span>
          </template>
        </el-table-column>
        <el-table-column label="提醒周期" min-width="135" align="center">
          <template slot-scope="scope">
            <span v-for="(week, index) in scope.row.weeks" :key="index">{{ getWeekName(week) }}<span v-if="index !== (scope.row.weeks.length - 1)">,</span></span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="130">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editClock(scope.row, scope.$index)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  <!--  18、330定位  -->
  <div v-if="indexActive === 19">
    <div style="height: 160px">
      <div style="height: 20px"></div>
      <div class="line-btn">
        <div class="btn-name">定位间隔</div>
        <div class="btn-text">
          <span style="color: #1A1A1A" v-if="locationObj.time !== ''">
            <span>{{locationObj.time}}</span>分钟
          </span>
          <span v-else>请设置定位间隔</span>
        </div>
        <div class="btn-arrow"><el-button type="primary" @click="openSetLocation">设置</el-button></div>
      </div>
    </div>
  </div>
  <!--  20、330SOS按键号码  -->
  <div v-if="indexActive === 20">
    <div style="height: 160px">
      <div style="height: 20px"></div>
      <div class="line-btn">
        <div class="btn-text">
          <span style="color: #1A1A1A" v-if="phoneSOS.phone !== ''">
            <span>【{{phoneSOS.name}}】</span>
            <span>{{phoneSOS.phone}}</span>
          </span>
          <span v-else>请设置SOS按键号码</span>
        </div>
        <div class="btn-arrow"><el-button type="primary" @click="openSetSos">设置</el-button></div>
      </div>
    </div>
  </div>
  <!--  21、780设置高度  -->
  <div v-if="indexActive === 21">
    <div style="height: 160px">
      <div style="height: 20px"></div>
      <div class="line-btn">
        <div class="btn-name">安装高度</div>
        <div class="btn-text">
          <span style="color: #1A1A1A" v-if="installHeight.height !== ''">
            <span>{{installHeight.height}}</span>cm
          </span>
          <span v-else>请设置</span>
        </div>
        <div class="btn-arrow"><el-button type="primary" @click="openSetHeight">设置</el-button></div>
      </div>
    </div>
  </div>
  <el-dialog :visible.sync="popupShow" v-if="popupShow" width="550px" :show-close="true" :close-on-click-modal="false"
             center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div><span>{{popupObj.title}}</span></div>
      <div class="line-title"></div>
      <div v-if="indexActive === 16 || indexActive === 20">
        <el-form style="margin: 20px" :model="phoneForm" :rules="phoneRules" ref="phoneForm" label-width="70px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="phoneForm.name"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input type="number" v-model="phoneForm.phone"></el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="popupShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitFamilySos('phoneForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 17">
        <el-form style="margin: 20px" :model="whiteForm" :rules="phoneRules" ref="whiteForm" label-width="70px" class="demo-ruleForm">
          <el-form-item label="电话" prop="phone">
            <el-input type="number" v-model="whiteForm.phone"></el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="popupShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitWhite('whiteForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 18">
        <el-form style="margin: 20px;text-align: left" :model="clockForm" :rules="phoneRules" ref="clockForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="提醒时间" prop="time">
            <el-time-picker v-fixZoom v-model="clockForm.time" placeholder="请选择" format="HH:mm" value-format="HH:mm" style="width: 100%"></el-time-picker>
          </el-form-item>
          <el-form-item label="闹钟类型" prop="type">
            <el-radio-group v-model="clockForm.type">
              <el-radio :label="0">生效</el-radio>
              <el-radio :label="1">失效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="闹钟类型" prop="weeks">
            <el-checkbox-group v-model="clockForm.weeks">
              <el-checkbox v-for="item in weekArr" :label="item.id" :key="item.id">{{item.week}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="popupShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitClock('clockForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 19">
        <el-form style="margin: 20px" :model="locationForm" :rules="phoneRules" ref="locationForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="定位间隔" prop="time">
            <el-input type="number" placeholder="请输入" v-model="locationForm.time" style="width: 100%;">
              <template slot="append">分钟</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="popupShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitLocation('locationForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
      <div v-if="indexActive === 21">
        <el-form style="margin: 20px" :model="heightForm" :rules="phoneRules" ref="heightForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="安装高度" prop="height">
            <el-input type="number" placeholder="请输入" v-model="heightForm.height" style="width: 100%;">
              <template slot="append">cm</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div style="height: 60px;margin: 30px 30px 0">
          <el-row>
            <el-col :span="12"><div class="cancel-btn" @click="popupShow = false"><span>取消</span></div></el-col>
            <el-col :span="12"><div class="send-btn" @click="submitHeight('heightForm')"><span>确定</span></div></el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {querycommand, sendcommand} from '../../../api/device'

export default {
  name: 'listTabsSet',
  model: {
    prop: 'listShowSet',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      deviceRow: {
        devicetype: 0
      },
      tabs: [],
      indexActive: 16,
      // 16、亲情号
      phoneFamilyList: [],
      // 17、白名单
      phoneWhiteList: [],
      // 18、闹钟
      alarmClockList: [
        {id: 1, time: '00:00', weeks: [], type: 1},
        {id: 2, time: '00:00', weeks: [], type: 1},
        {id: 3, time: '00:00', weeks: [], type: 1}
      ],
      weekArr: [
        {id: 0, week: '周日'},
        {id: 1, week: '周一'},
        {id: 2, week: '周二'},
        {id: 3, week: '周三'},
        {id: 4, week: '周四'},
        {id: 5, week: '周五'},
        {id: 6, week: '周六'}
      ],
      // 19、定位
      locationObj: {time: ''},
      // 20、SOS按键号码
      phoneSOS: {name: '', phone: ''},
      // 21、780安装高度
      installHeight: {height: ''},

      popupShow: false,
      phoneForm: {name: '', phone: ''}, // 亲情号\sos
      whiteForm: {phone: '', time: ''}, // 白名单
      clockForm: {id: '', time: '00:00', weeks: [], type: 1}, // 闹钟
      locationForm: {time: ''},
      heightForm: {height: ''},
      phoneRules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入', trigger: 'blur' }],
        time: [{ required: true, message: '请选择', trigger: 'change' }],
        type: [{ required: true, message: '请选择', trigger: 'change' }],
        weeks: [{ required: true, message: '请选择', trigger: 'change' }],
        height: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      popupObj: {
        title: '',
        indexEdit: '' // 编辑、删除使用
      }
    }
  },
  created () {
    this.deviceRow = this.listObj.deviceRow
    this.getTabs()
    this.getDeviceCommand()
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    getTabs () {
      console.log(this.deviceRow.devicetype)
      if (this.deviceRow.devicetype === 330 || this.deviceRow.devicetype === 331) {
        this.tabs = [
          {index: 16, name: '亲情号'},
          {index: 20, name: 'SOS按键号码'},
          {index: 17, name: '白名单'},
          {index: 18, name: '闹钟'},
          {index: 19, name: '定位'}
        ]
        this.indexActive = 16
      } else if (this.deviceRow.devicetype === 780) {
        this.indexActive = 21
      }
    },
    // 获取设备设置
    getDeviceCommand () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id
      }
      querycommand(data).then(res => {
        let vm = this
        let resDatas = res.data
        if (resDatas !== null) {
          for (let i = 0; i < resDatas.length; i++) {
            let resData = resDatas[i]
            let key = resData.key
            let value = resData.value ? JSON.parse(resData.value) : ''
            if (key === 'deviceset') {
            } else {
              if (key === 'normalbutton') {
                let command1 = value.command1 !== '' ? value.command1.split('|') : []
                let command2 = value.command2 !== '' ? value.command2.split('|') : []
                let phoneList = []
                for (let i = 0; i <= command1.length - 1; i++) {
                  if (i === 0) {
                    vm.phoneSOS = {phone: command1[i], name: command2[i]}
                  } else {
                    phoneList.push({phone: command1[i], name: command2[i]})
                  }
                }
                vm.phoneFamilyList = phoneList
              } else if (key === 'phonein330') {
                let command1 = value.command1 !== '' ? value.command1.split('!') : []
                let whiteList = []
                command1.forEach(item => {
                  let phone = item.split('=')
                  whiteList.push({phone: phone[0], time: phone[1]})
                })
                this.phoneWhiteList = whiteList
              } else if (key === 'setclock330') {
                let command1 = value.command1 !== '' ? value.command1.split('@') : []
                let alarmClockList = [
                  {id: 1, time: '00:00', weeks: [], type: 1},
                  {id: 2, time: '00:00', weeks: [], type: 1},
                  {id: 3, time: '00:00', weeks: [], type: 1}
                ]
                command1.forEach(clock => {
                  let clocks = clock.split('!')
                  let times = clocks[0].split('=')
                  let weeks = clocks[1] === '' ? [] : clocks[1].split('+')
                  let endWeeks = []
                  weeks.forEach(we => {
                    endWeeks.push(parseInt(we))
                  })
                  let obj = {id: parseInt(times[0]), time: times[1].slice(0, 2) + ':' + times[1].slice(2, 4), weeks: endWeeks, type: parseInt(clocks[2])}
                  let idx = alarmClockList.findIndex(r => r.id === obj.id)
                  if (idx !== -1) {
                    alarmClockList[idx] = obj
                  }
                })
                vm.alarmClockList = alarmClockList
              } else if (key === 'setfrequencylocation') {
                this.locationObj.time = value.command1
              } else if (key === 'setinstallheight') {
                this.installHeight.height = value.command1
              }
            }
          }
        }
      }).catch(() => {})
    },
    addOpen () {
      if (this.indexActive === 16) {
        this.phoneForm = {name: '', phone: ''}
        this.popupObj.title = '新增电话'
      } else if (this.indexActive === 17) {
        if (this.phoneWhiteList.length === 20) {
          this.$message({message: '白名单已达上限。', type: 'warning'})
          return
        }
        this.whiteForm = {phone: '', time: ''}
        this.popupObj.title = '新增白名单'
      }
      this.popupShow = true
    },
    // 编辑亲情号
    editPhoneFamily (row, index) {
      this.phoneForm = row
      this.popupObj.indexEdit = index
      this.popupObj.title = '编辑电话'
      this.popupShow = true
    },
    // 删除亲情号
    delPhoneFamily (row, index) {
      let vm = this
      this.$confirm('此操作将永久删除该亲情号【' + row.phone + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        vm.popupObj.title = '删除电话'
        vm.popupObj.indexEdit = index
        vm.submitCommandSet('normalbutton')
      }).catch(() => {})
    },
    // 编辑白名单
    editPhoneWhite (row, index) {
      this.whiteForm = row
      this.popupObj.indexEdit = index
      this.popupObj.title = '编辑白名单'
      this.popupShow = true
    },
    // 删除白名单
    delPhoneWhite (row, index) {
      console.log(this.phoneWhiteList)
      let vm = this
      this.$confirm('此操作将永久删除该白名单【' + row.phone + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        vm.popupObj.title = '删除白名单'
        vm.popupObj.indexEdit = index
        vm.submitCommandSet('phonein330')
      }).catch(() => {})
    },
    getWeekName (week) {
      let name = week
      this.weekArr.forEach(item => {
        if (item.id === week) {
          name = item.week
        }
      })
      return name
    },
    // 编辑闹钟
    editClock (row, index) {
      this.clockForm = row
      this.popupObj.indexEdit = index
      this.popupObj.title = '编辑闹钟'
      this.popupShow = true
    },
    // 设置SOS按键号码
    openSetSos () {
      this.phoneForm = this.phoneSOS
      this.popupObj.title = '设置SOS按键号码'
      this.popupShow = true
    },
    // 亲情号/sos
    submitFamilySos (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommandSet('normalbutton')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 白名单
    submitWhite (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommandSet('phonein330')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 闹钟
    submitClock (formName) {
      console.log(this.clockForm)
      this.clockForm.weeks = this.clockForm.weeks.sort((a, b) => {
        return a - b
      })
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommandSet('setclock330')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 定位
    openSetLocation () {
      this.locationForm = this.locationObj
      this.popupObj.title = '设置定位'
      this.popupShow = true
    },
    openSetHeight () {
      this.heightForm = this.installHeight
      this.popupObj.title = '设置高度'
      this.popupShow = true
    },
    submitLocation (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommandSet('setfrequencylocation')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitHeight (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.submitCommandSet('setinstallheight')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitCommandSet (met) {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: met
      }
      let sendArr = []
      if (met === 'normalbutton') {
        let command1 = ''
        let command2 = ''
        if (this.indexActive === 16) {
          sendArr = this.clone(this.phoneFamilyList)
          if (this.popupObj.title === '新增电话') {
            sendArr.push(this.phoneForm)
          } else if (this.popupObj.title === '编辑电话') {
            sendArr[this.popupObj.indexEdit] = this.phoneForm
          } else if (this.popupObj.title === '删除电话') {
            sendArr = sendArr.filter((item, i) => i !== this.popupObj.indexEdit)
          }
          sendArr.unshift(this.phoneSOS)
        } else if (this.indexActive === 20) {
          sendArr = [this.phoneForm]
          sendArr = sendArr.concat(this.phoneFamilyList)
        }
        sendArr.forEach((item, index) => {
          command1 += index !== 0 ? '|' + item.phone : item.phone
          command2 += index !== 0 ? '|' + item.name : item.name
        })
        data.command1 = command1
        data.command2 = command2
      } else if (met === 'phonein330') {
        sendArr = this.clone(this.phoneWhiteList)
        if (this.popupObj.title === '新增白名单') {
          sendArr.push(this.whiteForm)
        } else if (this.popupObj.title === '编辑白名单') {
          sendArr[this.popupObj.indexEdit] = this.whiteForm
        } else if (this.popupObj.title === '删除白名单') {
          sendArr = sendArr.filter((item, i) => i !== this.popupObj.indexEdit)
        }
        console.log(sendArr)
        let command1 = ''
        sendArr.forEach(item => {
          if (command1 === '') {
            command1 = item.phone + '=0000-2359+0000-2359'
          } else {
            command1 = command1 + '!' + item.phone + '=0000-2359+0000-2359'
          }
        })
        data.command1 = command1
      } else if (met === 'setclock330') {
        sendArr = this.clone(this.alarmClockList)
        if (this.popupObj.title === '编辑闹钟') {
          sendArr[this.popupObj.indexEdit] = this.clockForm
        }
        let command1 = ''
        sendArr.forEach(item => {
          let times = item.time.split(':')
          let weeks = ''
          item.weeks.forEach(week => {
            weeks += weeks === '' ? week : '+' + week
          })
          if (command1 !== '') {
            command1 += '@'
          }
          command1 += item.id + '=' + times[0] + times[1] + '!' + weeks + '!' + item.type
        })
        data.command1 = command1
      } else if (met === 'setfrequencylocation') {
        let command1 = this.locationForm.time + ''
        data.command1 = command1
      } else if (met === 'setinstallheight') {
        let command1 = this.heightForm.height + ''
        data.command1 = command1
      }
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '成功设置设备', type: 'success', duration: 2000 })
        this.popupShow = false
        this.getDeviceCommand()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.content-info{
  margin: 0 30px;
  height: 400px;
  overflow-y: auto;
  background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/listTabsSet.vue